import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { LoadingComponent } from 'components/Loading/LoadingComponent';
import { useSearch } from 'hooks/useSearch';
import { GlobalBox } from 'components/Box/GlobalBox';
import { Grid } from '@mui/material';
import RegularButton from 'components/CustomButtons/Button';
import { LeakAdd, Lock, LockOpen, Inventory , SearchRounded } from '@mui/icons-material';
import {
    setInventoryStatusFilters,
    getInventoryStatusReasons,
    getInventoryStatusSyncWarehouse,
    getInventoryStatusIsClosed,
    closeInventoryStatus,
    reopenInventoryStatus,
} from 'redux/actions/inventoryStatus/inventoryStatusActions';
import InventoryStatusTabs from './InventoryStatusTabs';
import { useToggle } from 'hooks/useToggle';
import { ModalV2 } from 'components/Modal/ModalV2';
import { PERMISSIONS } from "router/permissions";
import dayjs from 'dayjs';
import { newDate } from "helpers/dateTools";
import { TableInputs } from "components/CardTable/TableInputs";

export const InventoryStatus = () => {
    const dispatch = useDispatch();
    const { setSnackbar, buildCompLoadings } = useSearch();
    const { rules } = useSelector(({ login }) => login)
    const {
        date,
        station,
        unitType,
        reasonsOptions,
        inventoryPercentage,
        allowClosure,
        closurePercentage,
        closure
    } = useSelector(({ inventoryStatus }) => inventoryStatus)
    const { isLoadingComp } = useSelector(({ search }) => search);
    const [isOpenSync, handleIsOpenSync, handleSyncValue] = useToggle();
    const [isOpenClose, handleIsOpenClose] = useToggle();
    const [isOpenReopen, handleIsOpenReopen] = useToggle();
    const { DIGITAL_INVENTORIES_SYNC } = PERMISSIONS;
    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        if (!station?.id) setSnackbar('Selecciona una planta')
        else if (!unitType.length) setSnackbar('Selecciona un tipo de unidad')
        else {
            dispatch(getInventoryStatusIsClosed(station.id, date, unitType))
        }
    }, [date, station, unitType, setSnackbar, dispatch]);

    const handleSync = useCallback((e) => {
        e.preventDefault();
        if (!station?.id) setSnackbar('Selecciona una planta')
        else dispatch(getInventoryStatusSyncWarehouse(station.id, handleSyncValue))
    }, [station, setSnackbar, handleSyncValue]);

    const handleClose = useCallback((e) => {
        e.preventDefault();
        dispatch(closeInventoryStatus({ idStation: station?.id }, handleIsOpenClose))
    }, [station, handleIsOpenClose]);

    const handleReopen = useCallback((e) => {
        e.preventDefault();
        dispatch(reopenInventoryStatus(closure, !allowClosure ? 'reopen' : 'reclose', handleIsOpenClose))
    }, [closure, allowClosure, handleIsOpenClose]);

    useEffect(() => {
        if (!reasonsOptions?.length) dispatch(getInventoryStatusReasons())
        buildCompLoadings(['loadingInventoryStatus'])
    }, []);

    return (
        <>
            <GlobalBox icon={<Inventory />} title={'Inventario digital'}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12}>
                        <TableInputs
                            reducer="inventoryStatus"
                            date
                            stations
                            unitType
                            maxDate={newDate()}
                            dispatchAction={setInventoryStatusFilters}
                            loading={isLoadingComp?.loadingInventoryStatus}

                            submitAction={handleSubmit}
                            submitButtonName={<SearchRounded />}
                            submitActionTooltip='Buscar Inventario'

                            submitSecondButtonName={<LeakAdd />}
                            submitSecond={
                                rules.includes(DIGITAL_INVENTORIES_SYNC) &&
                                    !unitType?.every(type => type.value !== 'ALMACEN') ?
                                    handleIsOpenSync : null
                            }
                            submitSecondTooltip='Sincronizar Almacenes'
                            submitSecondColor='success'
                            submitThird={
                                rules.includes(DIGITAL_INVENTORIES_SYNC) &&
                                    inventoryPercentage &&
                                    inventoryPercentage >= closurePercentage &&
                                    dayjs(date).isValid() && dayjs(date).isSame(dayjs(), 'day') ?
                                    handleIsOpenClose : null
                            }
                            submitThirdButtonName={closure && !allowClosure ? <LockOpen /> : <Lock />}
                            submitThirdTooltip={closure && !allowClosure ? 'Reabrir Inventario' : 'Cerrar Inventario'}
                            submitThirdColor={closure && !allowClosure ? 'info' : 'danger'}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', paddingTop: 0 }}>
                        <InventoryStatusTabs />
                    </Grid>
                </Grid>
            </GlobalBox>
            {isLoadingComp?.loadingInventoryStatus ? <LoadingComponent label='Buscando Inventario' /> : null}
            <ModalV2
                open={isOpenSync || isOpenClose || isOpenReopen}
                onClose={
                    isOpenSync ? handleIsOpenSync
                        : isOpenClose ? handleIsOpenClose
                            : handleIsOpenReopen
                }
                justConfirm
                title={isOpenSync
                    ? 'Esta seguro que desea Sincronizar el inventario de Almacenes?'
                    : `Esta seguro que desea ${allowClosure ? 'Cerrar' : 'Reabrir'} el inventario digital?`
                }
                maxWidth='520px'
                textAlign='center'
            >
                <div style={{
                    marginTop: 14,
                    width: '100%',
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 8
                }}>
                    <RegularButton
                        color="info"
                        onClick={
                            isOpenSync ? handleIsOpenSync
                                : isOpenClose ? handleIsOpenClose
                                    : handleIsOpenReopen
                        }
                        disabled={isLoadingComp?.loadingInventoryStatus}
                    >
                        Cancelar
                    </RegularButton>
                    <RegularButton
                        color="danger"
                        onClick={
                            isOpenSync ? handleSync
                                : !closure ? handleClose
                                    : handleReopen
                        }
                        disabled={isLoadingComp?.loadingInventoryStatus}
                    >
                        Confirmar
                    </RegularButton>
                </div>
            </ModalV2>
        </>
    );
};